import { z } from 'zod';
import { tempoApi } from '@/common/api/tempoApi';
import { chunkBy } from '@/common/utils/chunkBy';

const INTEGRATION_ITEMS_BATCH_LIMIT = 50;

export const getIntegrationIdsByItemIds = async ({
  itemIds,
}: {
  itemIds: Set<number>;
}): Promise<Record<number, number>> => {
  if (itemIds.size === 0) return {};

  const chunks = chunkBy(Array.from(itemIds), INTEGRATION_ITEMS_BATCH_LIMIT);

  const allResults: Record<number, number> = {};
  for (const chunk of chunks) {
    const response = await tempoApi().post(
      'api/v1/work-integration/integration-items/by-item-ids',
      {
        json: chunk,
      },
    );
    const chunkResult = z.record(z.coerce.number().int(), z.number()).parse(await response.json());
    Object.assign(allResults, chunkResult);
  }

  return allResults;
};

export const deleteOrphanedIntegrationItem = async ({
  itemId,
}: {
  itemId: number;
}): Promise<void> => {
  await tempoApi().delete(`api/v1/work-integration/integration-items/items/${itemId}`);
};

export const IntegrationItemsApi = {
  getIntegrationIdsByItemIds,
  deleteOrphanedIntegrationItem,
};
